/** @format */

import {TanStackTableData} from 'components/Table/core/types';

import {ResolvedCellData} from '../components/ResolvedCell';
import {barWidth, downloadsBarColor, isNotNull} from '../helpers';
import {CompanyReportDownloadFromQuery} from '../types';

interface MapStaffOptions {
  amountOfWeeks: number;
}

export const mapStaffData = (
  downloads: ReadonlyArray<CompanyReportDownloadFromQuery>,
  {amountOfWeeks}: MapStaffOptions,
): TanStackTableData[] =>
  downloads.filter(isNotNull).map(item => {
    const metrics = (item.downloadMetrics ?? []).filter(isNotNull);

    const downloadsTotal = metrics.reduce((acc, metric) => acc + metric.downloads, 0);
    const clicksTotal = metrics.reduce((acc, metric) => acc + metric.directClickCount, 0);
    const opensTotal = metrics.reduce((acc, metric) => acc + metric.pageOpenCount, 0);

    const parentCell = (total: number): ResolvedCellData => ({
      display: total,
      bar: {width: total, color: downloadsBarColor(total, amountOfWeeks)},
    });

    const subCell = (value: number, total: number): ResolvedCellData => ({
      display: value,
      bar: {width: barWidth(value, total), color: downloadsBarColor(value, amountOfWeeks)},
    });

    const subRows: TanStackTableData[] = metrics.map(
      (metric, index) =>
        ({
          id: `${item.connectedUser.id}::sub::${index}`,
          staff: metric.company.name,
          projects: '',
          downloads: metric.downloads,
          directClicks: metric.directClickCount,
          pageOpens: metric.pageOpenCount,
          downloadsCell: subCell(metric.downloads, downloadsTotal),
          directClicksCell: subCell(metric.directClickCount, clicksTotal),
          pageOpensCell: subCell(metric.pageOpenCount, opensTotal),
        }) as unknown as TanStackTableData,
    );

    return {
      id: item.connectedUser.id,
      staff: item.connectedUser.profile?.name ?? '',
      projects: metrics.length,
      downloads: downloadsTotal,
      directClicks: clicksTotal,
      pageOpens: opensTotal,
      downloadsCell: parentCell(downloadsTotal),
      directClicksCell: parentCell(clicksTotal),
      pageOpensCell: parentCell(opensTotal),
      subRows: subRows.length ? subRows : undefined,
    } as unknown as TanStackTableData;
  });
